// import api from "./api";

// const requests = new Map<string, Promise<Record<string, any>>>();

// export const getCmsPage = async (pageSlug: string): Promise<Record<string, any>> => {
//   if (!requests.has(pageSlug)) {
//     requests.set(
//       pageSlug,
//       api.get(`/cms/${pageSlug}`)
//         .then((response) => response.data.data || {})
//         .finally(() => requests.delete(pageSlug)),
//     );
//   }
//   return requests.get(pageSlug)!;
// };

// export interface PublicStatistics {
//   totalListings: number;
//   verifiedDealers: number;
//   registeredUsers: number;
//   activeListings: number;
// }

// export const getPublicStatistics = async (): Promise<PublicStatistics> => {
//   const response = await api.get("/cms/statistics");
//   return response.data.data;
// };

import api from "./api";

const requests = new Map<string, Promise<Record<string, any>>>();

export const getCmsPage = async (
  pageSlug: string,
  lang = "en",
): Promise<Record<string, any>> => {
  const key = `${pageSlug}:${lang}`;
  if (!requests.has(key)) {
    requests.set(
      key,
      api
        .get(`/cms/public/${pageSlug}?lang=${encodeURIComponent(lang)}`)
        .then((response) => response.data.data || {})
        .finally(() => requests.delete(key)),
    );
  }
  return requests.get(key)!;
};

export interface PublicStatistics {
  totalListings: number;
  verifiedDealers: number;
  registeredUsers: number;
  activeListings: number;
}

export const getPublicStatistics = async (): Promise<PublicStatistics> => {
  const response = await api.get("/cms/statistics");
  return response.data.data;
};